<div class="eSparsh-payment-container">

    <div class="p-fluid p-formgrid top-card">
        <div class="field md:col-4 col-12">
            <div class="grid-item">
                <p-dropdown [options]="contractorList" [(ngModel)]="selectedContractor"
                    (onChange)="onSelectContractor()" appendTo="body" placeholder="{{ 'Select Contractor'| translate }}"
                    optionLabel="ContractorName"></p-dropdown>
            </div>
        </div>
    </div>

    <div *ngIf="showDetailTable" class="grid">
        <div class="col-12">
            <div class="card">
                <div class="dashboardTable">
                    <p-table #readyForPaymentTable [value]="lotTableData" dataKey="APP_ID" [rows]="10"
                        [paginator]="true" [globalFilterFields]="[
                        'Lot_No',
                        'AppCount',
                        'Centre_share_amt',
                        'State_share_amt',
                        'TopUp',
                        'TotalRecommendedAmt',
                        'CreatedDate',
                        'PFMSPaymentDate',
                        'ProgramCount',
                        'CAORemarks',
                        'LotStatus',
                        ]" responsiveLayout="scroll" [rowHover]="true" sortMode="multiple"
                        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                        [showCurrentPageReport]="true" [loading]="loading">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <!-- Left side -->
                                <div class="col-5">
                                    <h5 class="m-0 table-header-text">{{'EPC Generated Lot Details'| translate}}</h5>
                                </div>
                                <!-- Middle section for buttons -->
                                <div class="col-4 d-flex  justify-content-between">
                                    <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
                                        class="p-button-info mx-1"></button>
                                </div>
                                <!-- Right side for search -->
                                <!-- <div class="col-3 d-flex align-items-center justify-content-end">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="readyForPaymentTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div> -->
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="Lot_No">{{'LOT_NO'| translate}}</th>
                                <th>{{'NO_OF_RECORDS'| translate}}</th>
                                <th>{{'CENTER_SHARE_AMOUNT'| translate}}</th>
                                <th>{{'STATE_SHARE_AMOUNT'| translate}}</th>
                                <th>{{'TOP_UP_AMOUNT'| translate}}</th>
                                <th>{{'TOTAL_AMOUNT'| translate}}</th>
                                <th>{{'CREATED_DATE'| translate}}</th>
                                <th>{{'PAYMENT_DATE'| translate}}</th>
                                <!-- <th>{{'CAO_REMARKS'| translate}}</th> -->
                                <th>{{'LOT_STATUS'| translate}}</th>
                                <th>{{'MB_DOCUMENT'| translate}}</th>
                                <th>{{'TAX_CALCULATION_AND_RECOVERY_SHEET'| translate}}</th>
                                <!-- <th>{{'UPLOAD'| translate}}</th> -->
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <!-- <td><button (click)="(product.Lot_No, '')" pButton pRipple type="button"
                                        label="{{product.Lot_No}}" class="p-button-text"></button></td> -->
                                <td>{{product.Lot_No}}</td>
                                <td>{{product.AppCount}}</td>
                                <td>{{product.Centre_share_amt}}</td>
                                <td>{{product.State_share_amt}}</td>
                                <td>{{product.TopUp}}</td>
                                <td>{{product.TotalRecommendedAmt}}</td>
                                <td>{{product.CreatedDate | date:'mediumDate'}}</td>
                                <td>{{product.PFMSPaymentDate | date:'mediumDate'}}</td>
                                <!-- <td>{{product.CAORemarks}}</td> -->
                                <td>{{product.LotStatus}}</td>
                                <td>
                                    <a *ngIf="product?.MBDocPath" style="cursor: pointer" icon="pi pi-eye" [href]="product?.MBDocPath" target="_blank">
                                        <button pButton type="button"
                                            class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                                            pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                    </a>
                                </td>
                                <td>
                                    <a *ngIf="product?.TaxDocPath" style="cursor: pointer" icon="pi pi-eye" [href]="product?.TaxDocPath" target="_blank">
                                        <button pButton type="button"
                                            class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                                            pTooltip="{{ 'VIEW' | translate }}" icon="pi pi-eye"></button>
                                    </a>
                                </td>
                                <!-- <td style="width:160px; text-align:center;">
                                    <button pButton type="button" icon="pi pi-upload" class="p-button-plain" title="Upload MB & Tax Rate" label="Upload MB" (click)="onClickUpload(product)" ></button>
                                </td> -->
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex">
                                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{lotTableData ? lotTableData.length : 0 }}
                                    {{'Lot(s) created'| translate}}.
                                </p>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">No Data found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog [(visible)]="openDialog" [modal]="true" [style]="{ width: '80%', height: 'auto' }" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="hideDialog()">

        
</p-dialog>